// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatRemoveMemberBody = {
  chatId: string;
  userId: string;
};

export type typeChatRemoveMemberOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isRemoved: boolean };
};

export type typeChatRemoveMemberOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatRemoveMemberOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatRemoveMemberOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatRemoveMemberBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    userId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["chatId", "userId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatRemoveMember(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatRemoveMemberBody);
  }

  return async function postChatRemoveMember(
    payload: typeChatRemoveMemberBody,
  ): Promise<typeChatRemoveMemberOutput200 | typeChatRemoveMemberOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatRemoveMember" failed before calling the network. #03fd99757e93`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#03fd99757e93" },
        },
        data: null,
      } as typeChatRemoveMemberOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/remove-member`,
      httpMethod: "POST",
      options,
    })) as typeChatRemoveMemberOutput200 | typeChatRemoveMemberOutput400;
  };
}
